module.exports = __webpack_public_path__ + "img/desert.18b1fcd0.png";